import { Badge, Col, Container, FormCheck, ListGroupItem, Row } from 'react-bootstrap';
import { AnnotationExtra } from '../types/Annotations';

const annotationStateToClass = {
    Error: "badge bg-danger",
    Sent: "badge bg-success",
    Sending: "badge bg-warning text-dark",
    Skip: "badge bg-secondary",
    Pending: "badge bg-primary"
}

export function AnnotationComponent({ annotation, setAnnotations }: { annotation: AnnotationExtra; setAnnotations: React.Dispatch<React.SetStateAction<any[]>>; }) {
    return <ListGroupItem key={annotation.id}>
        <Container>
            <Row>
                <Col xs={1} className="d-flex">
                    <div className="align-self-center">
                        <FormCheck type="switch"
                            checked={annotation.skip === undefined || annotation.skip === false}
                            onChange={(e) => {
                                setAnnotations((oldAnnotations) => {
                                    const newAnnotations = oldAnnotations.map(a => {
                                        if (a.id === annotation.id) {
                                            return { ...a, skip: e.target.checked ? undefined : true };
                                        } else {
                                            return a;
                                        }
                                    });
                                    return newAnnotations
                                });
                            }} />
                        <div className={annotationStateToClass[annotation.state]}>
                            {annotation.state}
                        </div>
                        {annotation.error}
                    </div>
                </Col>
                <Col>
                    <div>{annotation.text}</div>
                    <figure className="p-1 rounded" style={{ borderLeft: ".25rem solid var(--bs-cyan)", backgroundColor: "var(--bs-gray-100)" }}>
                        <blockquote className="blockquote pb-1">
                            {annotation.target?.[0]?.selector?.[2]?.exact}
                        </blockquote>
                        <figcaption className="blockquote-footer mb-0 font-italic">
                            <a href="uri">{annotation.document?.title[0]}</a>
                        </figcaption>
                    </figure>

                    <div>{annotation?.tags.map((tag: string) => <Badge pill bg="secondary" className='me-1' key={tag}>
                        {tag}
                    </Badge>
                    )}</div>
                </Col>
            </Row>
        </Container>


    </ListGroupItem>;
}
